import React from 'react';

const DroneGanIcon = () => {
  return (
    <svg width="50" height="50" viewBox="0 0 79.61 79.61">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="5.34"
          y1="19.91"
          x2="74.27"
          y2="59.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#024284" />
          <stop offset="0.81" stopColor="#004587" />
          <stop offset="0.82" stopColor="#68a93e" />
        </linearGradient>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <circle
            cx="39.8"
            cy="39.8"
            r="38.56"
            style={{
              fill: 'none',
              strokeMiterlimit: '10',
              strokeWidth: '2.48162492794007px',
              stroke: 'url(#linear-gradient)',
            }}
          />
          <path
            d="M32.74,36.18H47.3l5.58,5.58-5.52,6.63H32.8l-5.6-6.73S32.83,36.27,32.74,36.18Z"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <polyline
            points="52.88 41.76 57.68 36.95 57.68 30.91"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <polyline
            points="27.32 41.76 23.14 36.95 23.14 30.91"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <line
            x1="16.27"
            y1="27.5"
            x2="29.96"
            y2="27.5"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <line
            x1="50.09"
            y1="27.5"
            x2="63.78"
            y2="27.5"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <line
            x1="32.8"
            y1="48.39"
            x2="29.12"
            y2="52.07"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <line
            x1="47.36"
            y1="48.39"
            x2="51.08"
            y2="52.1"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <circle
            cx="40.12"
            cy="43.61"
            r="1.97"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2.28858660421371px',
            }}
          />
        </g>
      </g>
    </svg>
  );
};

export default DroneGanIcon;
